export default __webpack_public_path__ + "static/media/02e_fold-11.e6b74e49.mp4";